(function () {
  const selector = '.buy-button-wrap--main-product';
  const observers = new WeakMap();

  function removeMorePaymentOptions(wrapper) {
    wrapper.querySelectorAll('more-payment-options-link').forEach((link) => link.remove());
  }

  function watchPaymentButtons(root) {
    const wrappers = Array.from(root.querySelectorAll(selector));
    if (root.matches && root.matches(selector)) wrappers.push(root);

    wrappers.forEach((wrapper) => {
      if (observers.has(wrapper)) return;

      const observer = new MutationObserver(() => removeMorePaymentOptions(wrapper));
      observer.observe(wrapper, { childList: true, subtree: true });
      observers.set(wrapper, observer);
      removeMorePaymentOptions(wrapper);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => watchPaymentButtons(document));
  } else {
    watchPaymentButtons(document);
  }

  document.addEventListener('shopify:section:load', (event) => watchPaymentButtons(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(selector).forEach((wrapper) => {
      observers.get(wrapper)?.disconnect();
      observers.delete(wrapper);
    });
  });
})();
